import React from "react";

/**
 * WTD Detailing & Tint — official brand logo (raster, transparent bg).
 * - variant="full": WTD mark + DETAILING & TINT tagline (1665x480)
 * - variant="mark": WTD mark only (1615x349)
 */
const SRC = {
  full: "/logo.png",
  mark: "/logo-mark.png",
};
const RATIO = {
  full: 1665 / 480,
  mark: 1615 / 349,
};

export default function Logo({ height = 56, variant = "full", className = "" }) {
  const v = variant === "mark" ? "mark" : "full";
  return (
    <img
      src={SRC[v]}
      alt="WTD Detailing & Tint"
      height={height}
      width={Math.round(height * RATIO[v])}
      className={`inline-block select-none ${className}`}
      style={{
        height,
        width: "auto",
        filter: "drop-shadow(0 0 18px rgba(31,94,255,0.28))",
      }}
      draggable={false}
    />
  );
}
